import DismissInteractionEvent, {
  type DismissBannerType
} from '~/events/DismissInteractionEvent';
import useRootData from '~/hooks/useRootData';
import useUser from '~/hooks/useUser';

export default function useDismissInteraction(bannerType: DismissBannerType) {
  const { isBot } = useRootData();
  const user = useUser();

  return () =>
    new DismissInteractionEvent({
      bannerType,
      gesture: 'click',
      guestId: user.guestId,
      isBot,
      placement: 'dismiss_button'
    }).send();
}
